import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { AdditionalFields } from '../common.types';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import type {
  SignAndStampUserLevel,
  SignAndStampUserLevelDocument,
} from './signAndStampUserLevel.types';

export const signAndStampUserLevelPullQueryBuilder = (document: SignAndStampUserLevelDocument) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query signAndStampFilesOnUserLevel(
      $siteId: Int!
      $disciplineId: Int!
      $lastModified: DateTime!
    ) {
      signAndStampFilesOnUserLevel(
        siteId: $siteId
        disciplineId: $disciplineId
        lastModified: $lastModified
      ) {
        fileId
        fileUUID
        fileCategory
        drawingType
        isImageFile
        pcsId
        sizeMb
        originalPath
        extension
        name
        originalFileName
        allowSpaccess
        legacyId
        siteId
        disciplineId
        fileDescription
        showOnReport
        isSaveForFuture
        userId
        dateCreated
        dateModified
        isDelete
      }
    }
  `);
  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastModified: doc?.dateModified ? doc?.dateModified : doc?.dateCreated,
    },
  };
};

export const signAndStampUserLevelPushQueryBuilder = (doc: SignAndStampUserLevel[]) => {
  const document = doc[0];
  const query = print(gql`
    mutation userSignAndStampFileInfo(
      $MobileUserSignAndStampInfoInput: MobileUserSignAndStampInfoInput
    ) {
      userSignAndStampFileInfo(userFileRequest: $MobileUserSignAndStampInfoInput) {
        fileId
        uUID
        inspectionId
        result
      }
    }
  `);

  const variables = {
    MobileUserSignAndStampInfoInput: document,
  };

  return {
    query,
    variables,
  };
};

export const signAndStampUserLevelPushModifier = (doc: SignAndStampUserLevelDocument) => {
  const obj: SignAndStampUserLevelDocument & {
    isBulkOperation: boolean;
    isLiStamp: boolean;
  } & AdditionalFields = {
    ...doc,
    isBulkOperation: false,
    isLiStamp: doc?.inspectionId?.length && doc?.fkAssetInspectionTask === 0 ? true : false,
  };
  const blackListedProp = [
    '_attachments',
    '_rev',
    '_deleted',
    'dateCreated',
    'dateModified',
    '_meta',
    'isDeleted',
  ];
  blackListedProp.forEach(property => {
    obj[property as keyof AdditionalFields] = undefined;
  });
  return obj;
};
